import { useState } from 'react';
import TokenService from '../service/tokenService'

export default function useToken(setIsLoading) {
  const [token, setToken] = useState();

  const checkToken = async (type) => {
    let userToken = null;
    const token = localStorage.getItem('token');
    if (!token) {
      setIsLoading(false)
      return userToken
    }
    const tokenService = new TokenService()
    if (type === 'student') {
      userToken = await tokenService.checkStudentToken(token)
    } else {
      userToken = await tokenService.checkUserToken(token)
    }
    handleUserToken(userToken, type);
  };

  const handleUserToken = (userToken, type) => {
    if (!userToken.token) {
      forceLogout();
    } else {
      saveToken(userToken)
    }
  };

  const saveToken = (userToken) => {
    localStorage.setItem('token', userToken.token);
    localStorage.setItem('user', JSON.stringify(userToken));
    setToken(userToken.token);
  };

  const forceLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken('');
    setIsLoading(false);
    // window.location.reload();
  }

  const setLandingPage = (user) => {
    console.log('setLandingPage')
  }

  const getUser = () => {
    const user = localStorage.getItem('user');
    return user;
  }

  const getUserJson = () => {
    const user = localStorage.getItem('user');
    return JSON.parse(user);
  }

  const getRole = () => {
    const rawUser = localStorage.getItem('user');
    const user = JSON.parse(rawUser);
    return user?.role;
  }

  const getUnit = () => {
    const rawUser = localStorage.getItem('user');
    const user = JSON.parse(rawUser);
    return user?.unit;
  }
  
  const getUnitSpcNo = () => {
    const rawUser = localStorage.getItem('user');
    const user = JSON.parse(rawUser);
    return user?.unitSpcNo;
  }

  const getToken = () => {
    const rawUser = getUser();
    const user = JSON.parse(rawUser);
    return user?.token;
  }

  const isAdmin = () => {
    const role = getRole();
    return role === 'admin';
    // return role === 'admin' || role === 'adminViewer';
  }

  const isAdminViewer = () => {
    const role = getRole();
    return role === 'adminViewer';
    // return role === 'admin' || role === 'adminViewer';
  }

  const isStudent = () => {
    const role = getRole();
    return role === 'student';
  }

  const isUnitAdminOrUnitSpcAdmin = () => {
    const role = getRole();
    return role === 'adminUnit' || role === 'adminUnitSpc';
  }

  const isUnitSpcAdmin = () => {
    const role = getRole();
    return role === 'adminUnitSpc';
  }

  const isUnitAdmin = () => {
    const role = getRole();
    return role === 'adminUnit';
  }

  return {
    checkToken,
    forceLogout,
    setToken: saveToken,
    token,
    getUser,
    getUserJson,
    isAdmin,
    isStudent,
    getToken,
    getRole,
    getUnit,
    getUnitSpcNo,
    isUnitAdminOrUnitSpcAdmin,
    isUnitSpcAdmin,
    isUnitAdmin,
    isAdminViewer
  }
}